'use client'

import { Moon, Sun } from 'lucide-react'
import { useTheme } from 'next-themes'
import { useSyncExternalStore } from 'react'

// The resolved theme is only known on the client, so the first client render must
// match the server HTML. useSyncExternalStore returns the server snapshot during
// hydration and the client snapshot afterwards - the hydration-safe way to detect
// "we are mounted" without a setState-in-effect cascade.
const NEVER_CHANGES = () => () => {}

export function ThemeToggle() {
	const { theme, setTheme, resolvedTheme } = useTheme()
	const mounted = useSyncExternalStore(
		NEVER_CHANGES,
		() => true,
		() => false
	)

	const isDark = resolvedTheme === 'dark'
	const toggleTheme = () => setTheme(theme === 'dark' ? 'light' : 'dark')

	if (!mounted) {
		return (
			<div className="flex items-center gap-0.5 p-0.5 rounded-md border border-border bg-background">
				<div className="w-6 h-6 rounded-full bg-muted flex items-center justify-center">
					<Sun className="h-3.5 w-3.5" />
				</div>
				<div className="w-6 h-6 rounded-full flex items-center justify-center">
					<Moon className="h-3.5 w-3.5" />
				</div>
			</div>
		)
	}

	return (
		// The invisible before: overlay extends the tap target to ~40px without growing the visual pill
		<button
			type="button"
			aria-label="Toggle theme"
			className={`theme-toggle relative flex items-center gap-0.5 p-0.5 rounded-md border cursor-pointer hover:bg-muted/20 transition-colors before:absolute before:-inset-1.5 before:content-[''] ${isDark ? 'border-border/50 bg-background/50' : 'border-border bg-background'}`}
			onClick={toggleTheme}
		>
			<div
				className={`w-6 h-6 rounded-full flex items-center justify-center transition-colors ${!isDark ? 'theme-toggle-active shadow-sm' : ''}`}
			>
				<Sun className="h-3.5 w-3.5" />
			</div>
			<div
				className={`w-6 h-6 rounded-full flex items-center justify-center transition-colors ${isDark ? 'theme-toggle-active shadow-sm' : ''}`}
			>
				<Moon className="h-3.5 w-3.5" />
			</div>
		</button>
	)
}
